import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { Box } from '@qga/roo-ui/components';
import { mediaQuery } from 'lib/styledSystem';

const SidebarContainer = styled(Box)`
  background: ${themeGet('colors.greys.porcelain')};
  border-radius: ${themeGet('radii.default')};
  border: 1px solid ${themeGet('colors.greys.alto')};
  box-shadow: ${themeGet('shadows.modal')};

  ${mediaQuery.minWidth.md} {
    border: none;
    box-shadow: none;
    padding: ${themeGet('space.8')};
    padding-top: 0;
    padding-left: 0;
    margin-right: ${themeGet('space.11')};
    margin-bottom: ${themeGet('space.20')};
  }
`;

export default SidebarContainer;
